import { render, staticRenderFns } from "./DownloadDisclaimerModal.vue?vue&type=template&id=4298f284&scoped=true"
import script from "./DownloadDisclaimerModal.vue?vue&type=script&lang=js"
export * from "./DownloadDisclaimerModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadDisclaimerModal.vue?vue&type=style&index=0&id=4298f284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298f284",
  null
  
)

export default component.exports